<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // Author Liang Gang Qiang
    // Date 2021-10-20 11:55:13

    import emCommonEditMixin from "@/mixin/em/common/edit";

    export default {
        name: "mintalMesPrdManagePlanEditView",
        mixins: [emCommonEditMixin],
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        }
    };
</script>